// extracted by mini-css-extract-plugin
export var footerGrid = "index-module--footer-grid--1d432";